import * as React from "react";
import type { SVGProps } from "react";
export const SvgMiscPaypal = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 14 14" {...props}>
    <path
      fill="currentColor"
      d="M11.706 4.945c.287.514.325 1.176.175 1.941-.432 2.22-1.91 2.987-3.8 2.987H7.79a.47.47 0 0 0-.464.396l-.023.13-.367 2.328-.02.1a.47.47 0 0 1-.463.395h-1.95a.282.282 0 0 1-.278-.325l.102-.647h.886l.554-3.512h.808c2.729 0 4.52-1.285 5.13-3.793ZM9.979 1.976c.445.507.574 1.057.44 1.917l-.037.21c-.43 2.2-1.802 3.177-4.058 3.177h-1.1a.825.825 0 0 0-.788.584l-.009-.001-.542 3.438H1.82a.03.03 0 0 1-.03-.035l1.516-9.631a.554.554 0 0 1 .547-.468H7.34c1.273 0 2.168.273 2.639.81Z"
    />
  </svg>
);
